<template>
    <div>
        <div class="modal right" tabindex="-1" role="dialog" id="exampleModalLong">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header p-2">
                        <h6 class="modal-title">Link Assets</h6>
                        <button
                            class="close text-white"
                            data-dismiss="modal"
                            aria-label="Close"
                            v-on:click="closeDialog()"
                            title="Close"
                            >
                            <span aria-hidden="true">
                                <cancel-icon tabindex="0" class="close-icon categorybrowse" style="height: 30px !important;
                                    width: 30px !important;
                                    color: #fff;">
                                </cancel-icon>
                            </span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div  ref="mappersList" class="value-style d-inline-flex bg-transparent rounded text-light input-fields searched-metadata-display-fields">
                            <div style="display:inline-flex;width:100%">
                                <table class="tabletable-with-border table-scroll small-first-col table-cell-styles" style="background: transparent; width: 100%;padding-inline-end:0px !important">
                                    <!-- <thead>
                                        <tr>
                                            <th style="width: 3%" class="text-left"></th>
                                            <th style="width: 87%" class="text-center"></th>
                                            <th style="width: 10%" class="text-center"></th>
                                        </tr>
                                    </thead> -->
                                    <tbody class="body-half-screen">
                                        <template v-for="op in selectedLinkList">
                                            <tr :key="op._id" class="comm-table-row">
                                                <td class="text-left" style="width: 22%;vertical-align: top;" :style="(isNewRow == op.uuid)?'width:34% !important':''">
                                                    <div style="display: inline-block;width: 100%;text-align: end;">
                                                        <Multiselect v-if="isNewRow == op.uuid"
                                                            :value="labelOflinksList[op.uuid]"
                                                            :options="linksList"
                                                            :searchable="true"
                                                            :close-on-select="true"
                                                            :allow-empty="false"
                                                            @select="updateRowType($event,op)"
                                                            label="inward_desc"
                                                            deselectLabel=""
                                                            selectLabel=""
                                                            selectedLabel=""
                                                            track-by="_id"
                                                            :show-labels="true"
                                                            placeholder="Select Link"
                                                            open-direction='below'>
                                                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                                                <span style="margin-inline-start:12px;">{{ scope.option.inward_desc }}</span>
                                                            </div>
                                                        </Multiselect>
                                                        <span v-else style="margin-top: 20px;width:100%;display:inline-block">{{labelOflinksList[op.uuid].inward_desc}}</span>
                                                    </div>
                                                </td>
                                                <td class="text-center" style="vertical-align: top;width:73%" :style="(isNewRow == op.uuid)?'width:66% !important':''">
                                                    <div class="comm-screen-profile-fields" style="display:flex;width:100%;display:inline-flex;">                                                       
                                                        <ul class="thumbnail-view-ul folder-view-ul" :style="op.linked_asset_info.length>0?'width:78%':'width:0%;'" style="display:inline-block;padding-inline-start:5px">
                                                            <li
                                                                class="folder-view-li"
                                                                v-for="assetInfo in op.linked_asset_info" :key="assetInfo._id"
                                                                @click.exact="loadPreview(assetInfo)"
                                                                :class="{ activeAssetID: activeAssetID == assetInfo._id , 'reduce-opacity': assetInfo.state == 'MARK FOR DELETE'}"
                                                                :title="assetInfo.slug_name">
                                                                <div class="folder-view" :class="assetInfo.asset_state == 'MARK FOR DELETE'?'reduce-opacity':' '">
                                                                    <div class="card" style="width: 34px; height: 78%; top:6px; overflow: hidden; display: flex; background-color: transparent;border-radius: 7px;">
                                                                        <img class="card-img-top" :src="getThumbnailPath(assetInfo)" @error="(e) => replaceByDefaultImage(e,assetInfo)" alt="Card image cap" style="height: 100%;max-width: inherit;max-height: inherit;width: inherit;object-fit: cover;background-color: transparent">
                                                                    </div>
                                                                    <img v-if="assetInfo.state == 'GROWING'" :src="growingFileGif" alt="markfordelete" style="height: 20px;width: 20px;position: relative;bottom: 72%;;">
                                                                    <img v-if="assetInfo.state == 'MARK FOR DELETE'" :src="markForDeleteIcn" alt="markfordelete" style="height: 20px;width: 20px;position: relative;bottom: 72%;;">
                                                                </div>
                                                                <div class="catalogs-data">
                                                                    {{ assetInfo.slug_name }}
                                                                </div>
                                                                <cancel-icon v-if="isEditing(op.uuid) || isNewRow == op.uuid" style="margin-top: 15px;margin-inline-start: 5px;" v-on:click.native="removeAsset(assetInfo, op.uuid)"></cancel-icon>
                                                            </li>
                                                        </ul>

                                                        <template v-if="!isEditing(op.uuid) && isNewRow != op.uuid">
                                                            <div class="fields-on-non-edit-mode" style="width:16%;"
                                                                v-on:dblclick.stop="editingKey = op.uuid">
                                                                <edit-icon v-on:click.native="enableEditMode(op.uuid)" class="editIconClass"></edit-icon>
                                                            </div>
                                                        </template>
                                                        <template v-else-if="isEditing(op.uuid) || isNewRow == op.uuid">
                                                            <div class="input-field-wrapper">
                                                                <div  class="save-icons" style="width: 100%;height: 45px;display: inline-flex;align-items: center;">
                                                                    <button title="Browse Assets" class="save-cancel-icon browse-icon" style="width: 40px; height: 30px;" @click="enableFileBrowser=true">
                                                                        <svg width="2em" height="1.8em" viewBox="0 0 16 16" class="bi bi-folder" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M9.828 4a3 3 0 0 1-2.12-.879l-.83-.828A1 1 0 0 0 6.173 2H2.5a1 1 0 0 0-1 .981L1.546 4h-1L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3v1z"></path>
                                                                            <path fill-rule="evenodd" d="M13.81 4H2.19a1 1 0 0 0-.996 1.09l.637 7a1 1 0 0 0 .995.91h10.348a1 1 0 0 0 .995-.91l.637-7A1 1 0 0 0 13.81 4zM2.19 3A2 2 0 0 0 .198 5.181l.637 7A2 2 0 0 0 2.826 14h10.348a2 2 0 0 0 1.991-1.819l.637-7A2 2 0 0 0 13.81 3H2.19z"></path>
                                                                        </svg>
                                                                    </button>
                                                                    <save-icon v-on:click.native="saveFieldComponentsValue(op.uuid)"></save-icon>
                                                                    <cancel-icon v-if="(isNewRow != op.uuid)" v-on:click.native="cancelEditMode(op.uuid)"></cancel-icon>
                                                                </div>
                                                            </div>
                                                        </template>
                                                        <div style="display: inline-flex;margin-top: 6px;justify-content: center;">
                                                            <delete-icon class="delete-btn"  @click.native="deleteLoadType(op.uuid,labelOflinksList[op.uuid].inward_desc)"
                                                                            style="float: inline-start;margin:8px;height:20px !important;width:20px; !important;" title="Delete Entry"></delete-icon> <!--:style="(isEditing(op.uuid) || (op._id == '0'))?'inset-inline-start :41px;':'inset-inline-start :10px;'"-->
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                        <tr class="comm-table-row">
                                            <td class="text-left" style="width:34%;padding-inline-start: 30px;">
                                                <div style="" class="add-screens-styles" @click="addNewLinkRow()">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                                    </svg>
                                                    Add Link
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer p-0 primary-btn-style">
                        <button class="btn btn-outline-secondary ml-1" title="Close" @click="closeDialog()">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
        <picture-in-picture ref="pic-pic" @hook:mounted="picPicZindex(99999, 'pic-pic')" calss="hide-picture" v-cloak v-if="openPip" :selectedFile="selectedFileInfo"  @closeMiniPlayer="closeMinimisedPlayer"></picture-in-picture>
        <ImagePreviewDialog ref="fullscreen-pic" @hook:mounted="picPicZindex(99999, 'fullscreen-pic')" class="hide-element-util-mount" v-cloak @maximisePlayer="showAssetDetailsDockCloseMiniplayer" :selectedFile="selectedFileInfo" @closeMiniPlayer="closeMinimisedPlayer"
            v-if="showOtherFilesPreviewDialog"></ImagePreviewDialog>
        <FilesBrowser v-if="enableFileBrowser" :enableAssetMultiSelect="true" :workspaceList="browseWorkspaceList" @close="enableFileBrowser=false" @handleFilesBrowse="handleFilesBrowse"></FilesBrowser>
    </div>
</template>
  
  
  
<script>
    import {mapActions, mapMutations} from "vuex";
    import Utils from "../../components.utils.js";
    import Constants from "../../components.constants.js";
    import { NotifierConstants } from "../../components.constants";
    import Multiselect from 'vue-multiselect';
    import CancelIcon from "../core/InlineCancelField.vue";
    import editIcon from "../core/InlineEditField.vue";
    import saveIcon from "../core/InlineSaveField.vue";
    import deleteIcon from "../core/InlineDeleteIcon.vue";
    import FilesBrowser from "../files/filesBrowse.vue";
    import PictureInPicture from "../files/MiniPlayer.vue";
    import ImagePreviewDialog from '../core/ImagePreviewDialog.vue';
  
    export default {
        props: ["fileInfo"],
        components:{
            "cancel-icon": CancelIcon,
            "Multiselect":Multiselect,
            "edit-icon":editIcon,
            "save-icon":saveIcon,
            "delete-icon":deleteIcon,
            FilesBrowser,
            PictureInPicture,
            ImagePreviewDialog
        },
        data() {
            return {
                selectedFileResp:null,
                options:{chunk:5},
                labelOflinksList:{},
                linksList:[],
                selectedLinkList : [],
                langDisplayValMapper:[],
                editingKey:null,
                isNewRow:null,
                selectedLoadwhenFilter:[],
                activeAssetID:null,
                enableFileBrowser:false,
                browseWorkspaceList:[Constants.WORKSPACE_CATALOG,Constants.WORKSPACE_BINS],
                showOtherFilesPreviewDialog:false,
                openPip:false,
                selectedFileInfo:null,
                growingFileGif: Utils.getLoadingGif(),
                markForDeleteIcn: Utils.getMarkForDeleteIcon(),
                emptyRowPresent:false
            };
        },
        methods: {
            picPicZindex(zvalue, ref){
                this.$refs[ref].$el.style.cssText += `z-index:${zvalue} !important`
            },
            closeMinimisedPlayer(){
                this.openPip = false;
                this.showOtherFilesPreviewDialog = false;
                this.selectedFileInfo = null;
                this.activeAssetID = null;
            },
            showAssetDetailsDockCloseMiniplayer(){
                if(this.showOtherFilesPreviewDialog) this.showOtherFilesPreviewDialog = false;
                    this.openPip = true;
            },
            loadPreview(assetInfo){
                this.selectedFileInfo = assetInfo;
                this.activeAssetID = assetInfo._id;
                this.openPictureInPicture();
            },
            
            openPictureInPicture(){
                if(this.isFullscreenPreviewAllowed()){
                    this.openPip = false;
                    this.showOtherFilesPreviewDialog = true;
                    return;
                }else{
                    this.openPip = true;
                    this.showOtherFilesPreviewDialog = false;
                }
            },

            isFullscreenPreviewAllowed(){
                let allowedFullScreenPreview = ['image',...Constants.supportedDocumentPreviewList,...Constants.supported3dModelPreviewList];
                return allowedFullScreenPreview.indexOf(Utils.getFileMediaType(this.selectedFileInfo)) > -1
            },
            getThumbnailPath(fileInfo){
                return Utils.getThumbnailPathfromFileInfo(fileInfo);
            },
            replaceByDefaultImage(e,fileInfo){
                e.target.onerror = null
                if(fileInfo && fileInfo.mime_type && fileInfo.mime_type.startsWith('audio')){
                    e.target.src = Utils.getAudioWaveformSvg();
                    return;
                }
                e.target.src = Utils.getNoThumbnailImg();
            },
            closeDialog(){
                this.$emit("close")
            },
            style(name){
                let style = {
                'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
                'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
                }
                return style
            },
            enableEditMode(keyUuid){
                if(this.editingKey){
                    this.cancelEditMode(this.editingKey)
                }
                this.isNewRow=null;
                this.editingKey = keyUuid;
            },
            isEditing(keyUuid) {
                return keyUuid === this.editingKey;
            },
            saveLangDictMapper(){
                let filteredMapper = this.selectedLinkList.filter(op=>op._id != Constants.loadEmpty)
                let emptyEntry = filteredMapper.find(op=>op.linked_asset_ids.length <= 0)
                if(emptyEntry){
                    alert("Please add valid Links.")
                    return
                }
                this.$emit('updateLangMapper', filteredMapper);
            },
            saveFieldComponentsValue(uuid){
                let loadM = this.selectedLinkList.find(e => e.uuid == uuid)
                if(loadM){
                    if(loadM.linked_asset_ids && loadM.linked_asset_ids.length <= 0){
                        alert("Please add valid Assets");
                        return
                    }
                    //check any asset is removed before saving
                    let isAssetRemoved = false;
                    if(this.selectedFileResp["link_info"]){
                        let oAsset = this.selectedFileResp["link_info"].find(op=>op.link_id == loadM.link_id)
                        if(oAsset){
                            oAsset.linked_asset_ids.forEach(itemA => {
                                // Check if itemA is not in array B
                                if (!loadM.linked_asset_ids.includes(itemA)) {
                                    isAssetRemoved = true;
                                }
                                });
                        }
                    }
                    this.updateLoadType(isAssetRemoved)
                }
            },
            updateRowType(newVal,oldVal){
                if(typeof newVal != "undefined" && typeof oldVal != "undefined"){
                    let oldValLabel = oldVal.inward_desc
                    if(this.selectedLoadwhenFilter.includes(newVal.inward_desc)){
                        alert("Already selected");
                        return;
                    }
                    let isTypeExists = false;
                    for(let loadType of this.selectedLinkList){
                        if(loadType.uuid == oldVal.uuid){
                            isTypeExists = true;
                            loadType._id = newVal._id;
                            loadType.link_id=newVal.inward_uid;
                            loadType.inward_desc = newVal.inward_desc;
                            this.isNewRow = loadType.uuid;
                            this.editingKey = loadType.uuid;
                            this.labelOflinksList[loadType.uuid] = {"inward_desc":newVal.inward_desc};
                            if(this.selectedLoadwhenFilter.includes(oldValLabel)){
                                this.selectedLoadwhenFilter.splice(this.selectedLoadwhenFilter.indexOf(oldValLabel), 1);
                            }
                            this.selectedLoadwhenFilter.push(newVal.inward_desc);
                            if(Object.keys(newVal).includes("_id")){
                                loadType.linked_asset_ids = []
                            }
                        }
                    }
                    if(!isTypeExists){
                        let newUuid = Utils.getUUID();
                        this.labelOflinksList[newUuid] = {"inward_desc":newVal.inward_desc};
                        let newEntry = {
                            "_id":newVal._id,
                            "uuid":newUuid,
                            "link_id":newVal.inward_uid,
                            "inward_desc":newVal.inward_desc,
                            "linked_asset_ids": [],
                            "linked_asset_info":[]
                        }
                        this.selectedLoadwhenFilter.push(newVal.inward_desc);
                        this.selectedLinkList.push(newEntry);
                        this.isNewRow = newUuid;
                        this.editingKey = newVal.uuid;
                    }
                }
            },
            checkForEmptyRow(){
                let emptyRowIndx = this.selectedLinkList.findIndex(op=>op._id == Constants.loadEmpty)
                if(emptyRowIndx >= 0){
                    this.emptyRowPresent = true;
                }else{
                    this.emptyRowPresent = false;
                }
            },
            addNewLinkRow(){
                this.checkForEmptyRow();
                if(this.emptyRowPresent){
                    return
                }
                let newUuid = Utils.getUUID();
                this.labelOflinksList[newUuid] = "";
                this.selectedLinkList.push({
                    "_id":Constants.loadEmpty,
                    "uuid":newUuid,
                    "link_id":"",
                    "inward_desc":"",
                    "linked_asset_ids":[],
                    "linked_asset_info":[],
                })
                this.isNewRow = newUuid
                if(this.$refs.mappersList){
                    this.$refs.mappersList.scrollTop = this.$refs.mappersList.scrollHeight;
                }
            },
            updateLoadType(fromDelete=false){
                // let emptyEntry = this.selectedLinkList.find(op=>op.linked_asset_ids.length <= 0)
                // if(emptyEntry){
                //     alert("Please add valid Links.")
                //     return
                // }
                let linkInfo = this.selectedLinkList.map(item => {
                                                            if (item.linked_asset_ids.length > 0) {
                                                                return {
                                                                    linked_asset_ids: item.linked_asset_ids,
                                                                    link_id: item.link_id,
                                                                    uuid: item.uuid
                                                                };
                                                            }
                                                        });
                let payload = {asset_ids: [this.selectedFileResp.asset_id], link_info:linkInfo}
                if(fromDelete){
                    payload["remove_links"] =true;
                }
                this.updateAssetsLink(payload).then((data) => {
                    if (Utils.isAcceptedStatusCode(data.statusCode)){
                        this.selectedFileResp["linked_asset_info"] = this.selectedLinkList
                        if('message' in data){
                            this.$toast.success(data.message);
                        }else{
                            this.$toast.success("Asset Updated successfully");
                        }
                        this.editingKey = null;
                        this.isNewRow = null;
                    } else {
                        this.$toast.error(data.message);
                    }
                });
            },
            deleteLoadType(loadTypeUuid,value){
                if(this.selectedLoadwhenFilter.includes(value)){
                    this.selectedLoadwhenFilter.splice(this.selectedLoadwhenFilter.indexOf(value), 1);
                }
                let tIndex = this.selectedLinkList.findIndex(t=>t.uuid==loadTypeUuid);
                this.selectedLinkList.splice(tIndex,1);
                if(value.trim().length > 0){
                    this.selectedLinkList = this.selectedLinkList.filter(op=> op._id != Constants.loadEmpty)
                    this.updateLoadType(true);
                }
            },
            cancelEditMode(uuid){
                let indx = this.selectedLinkList.findIndex(op=>op.uuid == uuid)
                if(indx >= 0){
                    let oldValLabel = this.selectedLinkList[indx].inward_desc;
                    if(this.selectedLoadwhenFilter.includes(oldValLabel)){
                        this.selectedLoadwhenFilter.splice(this.selectedLoadwhenFilter.indexOf(oldValLabel), 1);
                    }
                    let fetchEntry = this.selectedFileResp.link_info.find(op=>op.uuid == uuid)
                    if(fetchEntry){
                        this.$set(this.selectedLinkList[indx], "linked_asset_ids", fetchEntry['linked_asset_ids'])
                        this.$set(this.selectedLinkList[indx], "linked_asset_info", fetchEntry['linked_asset_info'])
                    }else{
                        this.selectedLinkList.splice(indx, 1);
                    }
                }
                this.editingKey = null;
                this.isNewRow = null;
            },
            removeAsset(assetInfo, uuid){
                if(assetInfo){
                    let indx = this.selectedLinkList.findIndex(op=>op.uuid == uuid)
                    if(indx >= 0){
                        this.$set(this.selectedLinkList[indx], "linked_asset_ids", this.selectedLinkList[indx].linked_asset_ids.filter(op=>op != assetInfo._id));
                        this.$set(this.selectedLinkList[indx], "linked_asset_info", this.selectedLinkList[indx].linked_asset_info.filter(op=>op._id != assetInfo._id));
                    }
                }else{
                    console.log("Invalid asset to remove ")
                }
            },
            async reloadFilters(){
                let data1 = await this.getAssetInfoFromServer({params:{assetId:this.fileInfo.asset_id}});
                if(Utils.isAcceptedStatusCode(data1.statusCode)){
                    this.selectedFileResp = data1.asset
                }
                // Deep copying selectedFileResp["link_info"] , so that on selectedLinkList update the prop will not be changed
                let parentAssetLinkType = []
                if('link_info' in this.selectedFileResp && this.selectedFileResp["link_info"]){
                    parentAssetLinkType = this.selectedFileResp["link_info"]
                }
                parentAssetLinkType.forEach(obj => {
                        // Check if the object has a uuid property
                        if (!('uuid' in obj)) {
                            // If uuid property is missing, add default uuid: 123
                            obj.uuid = Utils.getUUID();
                        }});
                this.selectedLinkList = []
                let linksInfoFromServer = JSON.parse(JSON.stringify(parentAssetLinkType));
                this.labelOflinksList = {};
                this.selectedLoadwhenFilter = [];
                if(typeof linksInfoFromServer != "undefined" && linksInfoFromServer.length > 0){
                    for(let loadC of linksInfoFromServer){
                        let validLink = false
                        let link_info = this.linksList.find(op=>op.inward_uid == loadC.link_id)
                        if(link_info){
                            validLink = true
                            this.labelOflinksList[loadC.uuid] = {"inward_desc":link_info.inward_desc};
                            this.selectedLoadwhenFilter.push(link_info.inward_desc);
                        }else{
                            let link_info = this.linksList.find(op=>op.outward_uid == loadC.link_id)
                            if(link_info){
                                validLink = true
                                this.labelOflinksList[loadC.uuid] = {"inward_desc":link_info.outward_desc};
                                this.selectedLoadwhenFilter.push(link_info.outward_desc);
                            }
                        }
                        if(validLink){
                            this.selectedLinkList.push(loadC)
                        }
                    }
                }else{
                    this.addNewLinkRow();
                }
            },
            handleFilesBrowse(selectedFiles){
                if(this.editingKey){
                    if(selectedFiles && selectedFiles.length>0){
                        let assetIdList = selectedFiles.map(item => item["_id"] !== undefined ? item["_id"] : item["id"]);
                        let indx = this.selectedLinkList.findIndex(op=>op.uuid == this.editingKey)
                        if(indx >= 0){
                            let allIds = this.selectedLinkList[indx]['linked_asset_ids'].concat(assetIdList);
                            let uniqueIds = [...new Set(allIds)];
                            this.$set(this.selectedLinkList[indx], "linked_asset_ids", uniqueIds)

                            let allAssetsInfo = this.selectedLinkList[indx]['linked_asset_info'].concat(selectedFiles)
                            let uniqueInfo = [...new Set(allAssetsInfo)];
                            this.$set(this.selectedLinkList[indx], "linked_asset_info", uniqueInfo)
                        }
                    }
                }else{
                    alert("Please select valid link.")
                }
                this.enableFileBrowser = false;
            },
            handleNotification(notification){
                notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
                if(notification.message && 'asset_ids' in notification.message && notification.message.asset_ids.includes(this.selectedFileResp.asset_id)){
                    setTimeout(() => {
                        this.reloadFilters();
                    }, 1000);
                }
            },
            handleAssetLinkTypeNotification(notification){
                notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
                if(notification.message){
                    let entry_info = notification.message
                    if ([NotifierConstants.AssetLinkTypeDeleted].includes(notification.message_type)){
                        let fIndex = this.linksList.findIndex(item=>item._id == entry_info._id);
                        if(fIndex >= 0){
                            this.linksList.splice(fIndex,1)
                        }
                        // Delete from the added row
                        let aIndx = this.selectedLinkList.findIndex(op=>op.link_id == entry_info.inward_uid);
                        if(aIndx>=0){
                            this.selectedLinkList.splice(aIndx, 1)
                        }else{
                            let oIndx = this.selectedLinkList.findIndex(op=>op.link_id == entry_info.outward_uid);
                            if(oIndx>=0){
                                this.selectedLinkList.splice(aIndx, 1)
                            }
                        }
                    }else if([NotifierConstants.AssetLinkTypeUpdated].includes(notification.message_type)){
                        let fIndex = this.linksList.findIndex(item=>item._id == entry_info._id);
                        if(fIndex >= 0){
                            this.linksList[fIndex] = entry_info
                        }
                        //Update label of link type
                        let aObj = this.selectedLinkList.find(op=>op.link_id == entry_info.inward_uid);
                        if(aObj){
                            this.$set(this.labelOflinksList[aObj.uuid],"inward_desc", entry_info.inward_desc)
                        }else{
                            let oObj = this.selectedLinkList.find(op=>op.link_id == entry_info.outward_uid);
                            if(oObj){
                                this.$set(this.labelOflinksList[oObj.uuid],"inward_desc", entry_info.outward_desc);
                            }
                        }
                        this.$forceUpdate();
                    }else if(notification.message_type == NotifierConstants.AssetLinkTypeCreated){
                        this.linksList.push(entry_info)
                    }
                }
            },
            registerforWebsocketNotifications(){
                this.addWSEventListener({eventname:[NotifierConstants.AssetLinksUpdated],callback:this.handleNotification,parent: "AssetsLinkViewOrEdit"})
                this.addWSEventListener({eventname:[NotifierConstants.AssetLinkTypeCreated, NotifierConstants.AssetLinkTypeUpdated, NotifierConstants.AssetLinkTypeDeleted],callback:this.handleAssetLinkTypeNotification,parent: "AssetsLinkViewOrEdit"})
            },
            UnregisterfromWebsocketNotifications(){
                this.removeWSEventListener({eventname:[NotifierConstants.AssetLinksUpdated],callback:this.handleNotification,parent: "AssetsLinkViewOrEdit"})
                this.removeWSEventListener({eventname:[NotifierConstants.AssetLinkTypeCreated, NotifierConstants.AssetLinkTypeUpdated, NotifierConstants.AssetLinkTypeDeleted],callback:this.handleAssetLinkTypeNotification,parent: "AssetsLinkViewOrEdit"})
            },
            ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
            ...mapActions("assets",["updateAssetsLink", "getAssetLinkTypesFromServer","getAssetInfoFromServer"]),
        },
        async created(){
            let data = await this.getAssetLinkTypesFromServer();
            if (Constants.acceptedStatusCodes.includes(data.statusCode)){
                this.linksList = data.link_types;
            }
            this.reloadFilters();
            this.registerforWebsocketNotifications();
        },
        beforeDestroy(){
            this.UnregisterfromWebsocketNotifications()
        }
    };
</script>
  
<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $secondary-border-color: 1px solid #2b2b2b;
    $border-on-hover: 1px solid #61707d;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $icon-hover:#2c3339;

    .table-scroll {
    /*width:100%; */
    border: none !important;
    /* Decoration */
    border-spacing: 0;
    // margin: 0px 15px;
    display:inline-block;
    height:100%;
        thead {
            color: $dull-text-color !important;
            position: relative;
            width: 100%;
            th {
            position: sticky;
            top: 0;
            background: $primary-background;
            z-index: 9;
            }
        }
        tbody {
            width: 100%;
            // overflow: auto;
            font-weight: 500;
            display:inline-block;
            tr {
                min-height: 45px;
                display:inline-block;
                width:100%;
            }
            tr:hover{
                background: $bg-color-on-hover !important;
            }
        }
    }

    .table {
        th {
            border-top: none !important;
            padding:0 10px !important;
        }
        td {
            border-top: none !important;
            padding:0 1rem!important;
            display:inline-block;
        }
    }

    th {
        border-top: none !important;
        padding:0 10px !important;
    }

    .table-cell-styles{
        td{
            padding:0 10px !important;
            display:inline-block;   
        }
    }

    .table-with-border {
        thead {
            border-bottom: $border-color;
        }
        tr {
            border-bottom: $border-color;
        }
    }

  
    .modal-dialog {
        max-width: 810px;
        width: 810px;
        max-height: 100%;
        margin: 0;
        padding: 0;
    }

    .modal{
        transition: opacity .3s ease;
    }

    .modal-content {
        min-height: 100%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
        background: $primary-background !important;
        border: $secondary-border-color;
        .modal-body{
            // overflow: auto;
            background: #1a1e21;
            padding: 1rem;
            // padding-inline-end: 0.4rem !important;
        }
    }

    .modal {
        text-align: center;
        padding: 0 !important;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        
    }
    .modal-header .close {
        // margin: -1rem -13px -1rem auto !important;
        margin:0px !important;
        padding: 0px !important;
    }
    .modal:before {
        content: '';
        display: inline-block;
        height: 100vh;
        vertical-align: middle;
        margin-inline-end: -4px;
        position: fixed;
        width: 100vw;
        inset-inline-start: 0;
        top: 0;
        background: #00000094;
    }
    .modal-dialog {
        display: inline-block;
        text-align: start;
        vertical-align: middle;
    }

    .btn{
        font-size:$input-field-and-label-font-size !important;
        height:100%;
    }

    .border{
        border: $border-color !important;
    }

    .modal-header{
        align-items: center
    }

    .modal-header,.modal-footer{
        border-top: $secondary-border-color !important;
        border-bottom: $secondary-border-color !important;
        background: $secondary-background-color;
        height: 58px;
        .modal-title{
            color:$text-color;
        }
    }

    .primary-btn-style{
        padding: 8px 16px !important;
        button{
            height: 35px;
            width: 75px;
            font-size:$input-field-and-label-font-size;
        }
    }

    .secondary-btn-style{
        color:$text-color;
    }

    .key-style {
        color: $dull-text-color;
        width: 16%;
        font-size: $input-field-and-label-font-size;
        margin-top: 11px;
    }

    .close-icon:hover{
        background: $icon-hover;
        border-radius: 20px;
    }

    .empty-field-text-styles{
        color:$none-text-color;
    }

    .input-field-wrapper{
        display: inline-flex;
        width: 16%;
        position: relative;
        // svg{
        //     position: absolute;
        //     inset-inline-end :-27px;
        //     top: 12px;
        //     height:25px;
        // }
    }

    .fields-on-non-edit-mode{
        width:70%;
        // display:inline-flex;
        line-height:46px;
        text-align: start;
    }

    .bigger-checkboxes {
        height: 30px;
        width: 20px;
        position:relative;
    }
    input[type="checkbox"]:after {
        line-height: 1.5em;
        content: "";
        display: inline-block !important;
        width: 22px !important;
        height: 21px !important;
        margin-top: 5px !important;
        margin-inline-start: -1px !important;
        border: $border-color !important;
        border-radius: 0.25em !important;
        background: $primary-background !important;
    }
    input[type="checkbox"]:checked:after {
        content: "✔";
        color: $active-blue !important;
        position: absolute !important;
        font-size: 16px !important;
        line-height: 1 !important;
        transition: all 0.2s !important;
        font-family: Helvetica, Arial, sans-serif;
        padding-inline-start: 4px !important;
        padding-top: 2px !important;
    }
  
    .user-name-or-image{
        height: 30px;
        width: 30px;
        border: $border-color;
        border-radius: 10px;
        text-align: center;
        line-height: 28px;
        text-transform: uppercase;
        margin-top: 3px;
    }
  
    .tags-display-ul{
        list-style-type: none;
    }
    
    .tags-display-ul .show-tags-delete{
        visibility:hidden;
    }
    
    .searched-metadata-display-fields{
        height: auto;
        // overflow: auto;
        width: 100%;
    }
    
    .view-tags:hover .show-tags-delete{
        visibility: visible;
    }
    
    .view-tags:hover {
        border: $border-on-hover !important;
    }
  
    .key-style {
        color: $dull-text-color;
        text-align: center;
        font-size: $input-field-and-label-font-size;
        padding-inline-start: 5px;
        padding-inline-end: 5px;
        margin-top: 13px;
    }
    
    .activeAssetID{
        color: $active-blue !important;
    }
    .view-tags{
        font-size: 12px;
        height: 52px !important;
        display: inline-flex;
        margin:2px !important;
        border: $border-color !important;
        border-radius: 15px !important;
        min-width: 50px;
        padding: 0px !important;
        text-align: center;
        width:auto !important;
        padding-inline-start: 12px !important;
        justify-content: center;
        padding-top: 1px !important;
        div{
            padding: 0px 8px;
            margin-inline-start: 0px;
            font-size: 12px;
            border-radius: 15px !important;
            position: relative;
            top: 1px;
        }
    }
  
    .view-fields-styles{
        font-size: 12px;
        height: 24px;
        display: inline-flex;
        margin:2px !important;
        border-radius: 15px !important;
        min-width: 50px;
        padding: 0px !important;
        text-align: start;
        width:98% !important;
        padding-inline-start: 12px !important;
        justify-content: start;
        padding-top: 1px !important;
        div{
            padding: 0px 8px;
            margin-inline-start: 0px;
            font-size: 14px;
            line-height: 32px;
            color: $secondary-text-color;
            text-align:end;
        }
    }
  
    .comm-input-field-style{
        background: $primary-background!important;
        width: 100%;
        float: inline-start;
        padding: $input-field-padding;
        border: $border-color!important;
        font-size:$input-field-and-label-font-size;
        height: 42px;
    }

    .comm-tags-field-wrapper-style{
        background: $primary-background!important;
        float: inline-start;
        padding: $input-field-padding;
        border: $border-color!important;
        font-size:$input-field-and-label-font-size;
        min-height: $input-field-height;
        margin-top:1px;
        margin-bottom:1px;
        border-radius: 4px;
    }
  
    ::v-deep{
        .theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
            background: $primary-background;
            border-bottom: $border-color;
        }
        .mx-input{
            background-color: $primary-background  !important;
            border: none !important;
            color: $text-color !important;
        }
        .mx-datepicker-main{
            border: $border-color !important;
            background: $secondary-background-color !important;
        }
        .mx-calendar-content .cell:hover{
            background-color: $bg-color-on-hover !important;
        }
        .mx-datepicker-range{
            width:auto;
        }
        .mx-calendar-content .cell:hover {
            color: #000000;
            background-color: #7d99b1;
        }
        .mx-icon-calendar{
            color:$text-color;
        }
    }
  
    .name-style{
        width: 100%;
        text-align: start;
        padding-top: 0px;
        padding-bottom: 3px;
        padding-inline-end: 5px;
        .slug-ellipsis{
            white-space: nowrap;
            max-width: 350px;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    .input-fields{
        border: none;
        border-radius: 0px !important;
        max-height: 345px;
        overflow: auto;
        // margin-inline-start:5px;
        // margin-bottom: 7px;
    }
  
    .input-fields:focus{
        outline: unset;
        border-bottom: 1px solid #0373ee !important;
    }
    
    .focusField{
        input:focus, select:focus{
          border:none !important;
        }
    }
    
    .tags-wrapper{
        position: absolute;
        inset-inline-end: 0px;
    }
    svg {
        color: #666666;
    }
    
    svg:hover {
        color: $text-color;
    }
   
    .delete-btn {
        visibility: hidden;
    }
    .comm-table-row:hover .delete-btn {
        visibility: visible;
        position: relative;
        // inset-inline-start :18px;
    }
    
    /* width */
    ::-webkit-scrollbar {
        width: 8px;
    }
  
    /* Track */
    ::-webkit-scrollbar-track {
        background: $scrollbar-track-background;
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $scrollbar-thumb-background;
    }
    
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $scrollbar-thumb-on-hover-background;
    }
  
    .height-set-for-component {
        height: calc(100% - 120px);
    }
  
    ::v-deep{
        .multiselect{
            // width:240px !important;
            width:100% !important;
            margin: 3px 0px;
        }
        .multiselect__content-wrapper{
            display:none;
        }
        .multiselect__tag, .tags-style {
            background-color: $primary-background !important;
            border: $border-color;
            border-radius: 5px;
            margin-bottom:0px;
        }
        .multiselect__tags, .tags-style {
            background: $primary-background !important;
            border: $border-color !important;
        }
        .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
        }
        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }
        .multiselect__tag-icon{
            color:$text-color;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after{
            color:$secondary-text-color !important;
            font-size: 20px;
        }
        .multiselect *{
            font-size: $input-field-and-label-font-size;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect__placeholder {
            padding-top: 0px;
            margin-bottom:0px;
        }
        .multiselect{
            color:$text-color !important;
            font-size: $input-field-and-label-font-size !important;
            min-height: 38px;
        }
        .multiselect__single{
            padding-top:3px;
        }
        .multiselect__option--selected{
            background: $bg-color-on-hover !important;
            color: $text-color;
        }
        .multiselect__content-wrapper{
            border: 1px solid $bg-color-on-hover !important;
            position: fixed !important;
            display: block;
            background: $text-color;
            width: 17% !important;
            max-height: 240px;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
            background: $secondary-background-color !important;
        }
        .multiselect__tags {
            background: $primary-background!important;
            height: auto;
            min-height: 38px;
        }
    }
  
    // .browse-icon{
    //     position: relative;
    //     inset-inline-start :8px;
    //     top: 8px;
    // }
    
    .table td, .table th {
        border-top: none;
        padding:0px;
    }
  
    .display-as-tags{
        display: inline-flex;
        flex-wrap: wrap;
        justify-content: start;
        float: inline-start;
    }
    
    .select-catalog-field{
        width: 101%;
        .name-style{
            width:100%;
        }
    }
  
    .editIconClass{
        visibility: hidden;
    }
    
    .comm-screen-profile-fields:hover{
        .editIconClass{
            visibility: visible;
            margin-inline-start: 8px;
        }
    }
  
    .user-name-or-image-in-selected-option{
        border: $border-color;
        height: 27px;
        width: 27px;
        border-radius: 5px;
        text-align: center;
        line-height: 26px;
        text-transform: uppercase;
        margin-top: -1px;
        margin-inline-start: -1px;
    }
  
    .tags-style{
        display: inline-flex;
        margin-inline-end: 5px;
        margin-bottom: 5px;
        height: 27px;
        margin-inline-start: 3px;
        float:inline-start;
        .user-name-display-as-tags{
            line-height: 27px;
            margin: 0px 5px;
            width:auto;
        }
    }
    .add-screens-styles{
        display: inline-flex;
        height: 45px;
        border: 1px solid $add-button-border-color;
        border-radius: 10px;
        width: 240px;
        margin-block: 8px;
        margin-inline-start: 0;
        margin-inline-end: 10px;
        color: $add-button-text-color;
        font-size: 15px;
        align-items: center;
        justify-content: center;
        svg{
            margin-inline-end: 7px;
            color:$add-button-text-color !important;
        }
    }

    .add-screens-styles:hover{
        border: 1px solid $add-button-border-on-hover;
        color:$add-button-text-color-hover;
        svg{
            color:$add-button-text-color-hover !important;
        }
    }
    .thumbnail-view-ul {
        list-style-type: none;
        display: grid;
        flex-wrap: wrap;
        padding: 0px;
        margin-top: 0px;
        width: 100%;
        padding-inline-start: 20px;
        justify-content: start;
        // overflow: auto;
        li {
            display: inline-block;
            margin-inline-end: 10px;
            width: 100%;
            padding-inline-start: 5px;
            margin-top: 5px;
            height: 128px;
            .asset-thumbnail {
                height: 90px;
                width: 160px;
                border-radius: 7px;
                margin-top: 8px;
                border:$border-color;
                position:relative;
                img {
                    max-width: 100%;
                    max-height: 100%;
                    border-radius: 7px;
                    object-fit: contain;
                    border-radius: 7px;
                }
            }
            .thumbnail-data {
                text-align: center !important;
            }
        }
    }
    .folder-view-ul {
        padding-bottom: 10px;
        margin-bottom: 10px;
        .folder-view-li {
            display: inline-flex !important;
            height: 52px !important;
            border: $border-color;
            border-radius: 6px;
            .folder-view {
                font-size: 30px;
            }
            .catalogs-data {
                margin-top: 15px;
                margin-inline-start: 7px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                text-align: start;
                white-space: nowrap;
                padding-inline-end: 12px;
            }
        }
    }
    .activeAssetID {
        border: 2px solid $active-blue !important;
        border-radius: 5px !important;
        .thumbnail-data {
            background: #1879e28c !important;
            position: relative;
            width: 102%;
            inset-inline-start: -4px;
            .svg-icons-display {
            inset-inline-end: 0px;
            bottom: -1px;
            }
        }
        .folder-view {
            svg {
            color: $active-blue !important;
            }
        }
    }
</style>